
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  EnumQuestionType,
  Option,
  QuestionCustom,
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";
import { update } from "lodash";
@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) exam!: any;
  @Prop({ default: new QuestionCustom() })
  questionCustomStruct!: QuestionCustom;

  updateAnswer(v: any, i: number) {
    this.$set(
      this.questionCustomStruct.blankQuestionConfig.answerList[i],
      "words",
      v
    );
    this.$forceUpdate();
  }

  updateScore(v: any, i: number) {
    this.$set(
      this.questionCustomStruct.blankQuestionConfig.answerList[i],
      "score",
      isNaN(Number(v)) ? 0 : Number(v)
    );
    this.$forceUpdate();
  }

  created() {
    //
  }
  mounted() {
    const a = this.exam;
    console.log(a);
  }

  ok() {
    this.$emit("ok", this.exam.templateName);
    //
  }

  //关闭
  close() {
    this.$emit("cancelMessage", false);
  }
}
